import {
  OwnerMenuItem,
  useGetOwnerList,
} from '@user/store/salesTeam/hooks/useGetOwnerList'
import { ENTITY_TYPES } from '@sales-center/common'

interface Props {
  salesTeamId: string
  assigneeId: string | null
}

export function useData(props: Props) {
  const { salesTeamId, assigneeId } = props

  const ownerList: OwnerMenuItem[] = useGetOwnerList(
    ENTITY_TYPES.Opportunity,
    +salesTeamId,
    false,
  )

  const filteredOwners = ownerList.map((user) => ({
    id: user.id,
    fullName: user.name,
    isPosition: user.isPosition,
    level: user.level,
  }))

  const salesTeamUsers = [
    {
      id: null,
      fullName: 'Unassigned',
      isPosition: false,
      level: 0,
    },
    ...filteredOwners,
  ]

  const initialValues = {
    salesFunnelStageId: 0,
    owner:
      assigneeId === null
        ? salesTeamUsers[0]
        : salesTeamUsers.find((user) => user.id === assigneeId) || null,
    expectedClosingDate: new Date(),
  }

  return {
    initialValues,
    owners: salesTeamUsers,
  }
}
